/* eslint-disable @typescript-eslint/no-extraneous-class */
/**
 * A service for determining bootstrap breakpoints based on screen width
 */
export class BootstrapBreakPointsService {
  static isXS(width: number): boolean {
    return width >= 0 && width < 576;
  }

  static isSM(width: number): boolean {
    return width >= 576 && width < 768;
  }

  static isMD(width: number): boolean {
    return width >= 768 && width < 992;
  }

  static isLG(width: number): boolean {
    return width >= 992 && width < 1024;
  }

  static isXL(width: number): boolean {
    return width >= 1024;
  }

  static isStrictXL(width: number): boolean {
    return width >= 1200;
  }
}
